import Vue from 'vue';
import eventBus from '../common/js/event-bus/event-bus';
import '../common/js/common';
import '../common/css/custom-properties.css';
import store from '../common/js/vuex/store';
import headerComponent from '../../source/frame/header/header';
import footerComponent from '../../source/frame/footer/footer';
import modal from '../common/components/modal/modal.vue';
import Tooltip from '../common/components/tooltip/Tooltip.vue';
import accordionModule from '../modules/accordion-module/accordion-module';
import vClickOutside from 'v-click-outside';
import VueMask from 'v-mask';
import i18n from '../common/js/lang/lang';
Vue.use(VueMask);
Vue.use(vClickOutside);
Vue.component('search', () => import(/* webpackChunkName: "applications/search" */ '../applications/search/search'));
Vue.component('notification', () => import(/* webpackChunkName: "applications/notification" */ '../common/components/notification/notification'));
Vue.component('tabs-module', () => import(/* webpackChunkName: "applications/tabs-module" */ '../modules/tabs/tabs.js'));
Vue.component('write-to-us', () => import(/* webpackChunkName: "applications/write-to-us" */ '../applications/write-to-us/write-to-us.vue'));
Vue.component('sweepstake-registration', () =>
	import(/* webpackChunkName: "applications/sweepstake-registration" */ '../applications/sweepstake-registration/sweepstake-registration.vue')
);
Vue.component('sweepstake-registration-members', () =>
	import(
		/* webpackChunkName: "applications/sweepstake-registration-members" */ '../applications/sweepstake-registration-members/sweepstake-registration-members.vue'
	)
);
Vue.component('calculator', () => import(/* webpackChunkName: "applications/calculator" */ '../applications/calculator/calculator.vue'));
Vue.component('tooltip', Tooltip);
Vue.component('accordion-module', accordionModule);
// import {mediaQueries} from '../common/js/media-query/media-query';

export default {
	i18n,
	data() {
		return {
			ariaHide: false
		};
	},
	// mediaQueries,
	methods: {
		initVhk() {
			// Inicializalja az osszes VHK webkomponenst
			const event = new CustomEvent('call-request-init');
			window.dispatchEvent(event);
		}
	},
	components: {
		headerComponent,
		footerComponent,
		modal
	},
	mounted() {
		eventBus.$on('toggleAriaHidden', (hide) => {
			this.ariaHide = hide;
		});
		this.initVhk();
	},
	store
};
